
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      router.replace(router.currentRoute.value.fullPath)
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
  }
}
import { default as indexQLbd_45_VEGEymTy61om4OM78JfxLHuFgCIu_qxD7KdRoMeta } from "/opt/buildhome/repo/pages/index.vue?macro=true";
import { default as loginKMdcZdjxVWBby7qzc8iax1m1i6js8gN3t8PvZM_RwR8Meta } from "/opt/buildhome/repo/pages/login.vue?macro=true";
import { default as profileR9_wsppREGZSR_45CuRHjAda5E9w1q2i4xh5hY7ddMHxQMeta } from "/opt/buildhome/repo/pages/profile.vue?macro=true";
import { default as about_45us_uxBuLYkM00cimo29xT3q99ktCMQX7EN_o7e5usDikwMeta } from "/opt/buildhome/repo/pages/about-us.vue?macro=true";
import { default as new1xYYwEQxiHsJKiTLvC5_ptHKrnAcOjs36nUFjEnY_1MMeta } from "/opt/buildhome/repo/pages/cafe/new.vue?macro=true";
import { default as _91id_93XQ_OlyxyAdoleQ6QX86fKn3F2v6uLOsCR4tSrifPXccMeta } from "/opt/buildhome/repo/pages/cafe/[id].vue?macro=true";
import { default as indexBeHzAQikKrSJqk6imgHKGnYps5J2m1dpAlMAyv_MDnQMeta } from "/opt/buildhome/repo/pages/blog/index.vue?macro=true";
import { default as indexAlTS9NbX9q_452wYazbmp2gHSp_45qg62ocmEl3pDL72HGwMeta } from "/opt/buildhome/repo/pages/cafe/index.vue?macro=true";
import { default as DisclaimerZw9vRYWOXbTLS2ahnJrGZQXyqDOQga_ZXUNNbM8eE_EMeta } from "/opt/buildhome/repo/pages/Disclaimer.vue?macro=true";
import { default as _91slug_93TVXfQgR7E_1etoF9MB3cfpp6TKNvvtjRnrJxWZr59DgMeta } from "/opt/buildhome/repo/pages/blog/[slug].vue?macro=true";
import { default as review7V42pK5IU0wWuQA2lYTZdARWq7CEey8su4sc8RfRopYMeta } from "/opt/buildhome/repo/pages/admin/review.vue?macro=true";
import { default as ig_45queue4jqERaVAxZs85kI6rhENnkEHIyFAiUIAUa_45ca_453lPFEMeta } from "/opt/buildhome/repo/pages/admin/ig-queue.vue?macro=true";
import { default as privacy_45policyek63hKQ8ZMx2nIQV88L2_dad1Zv4m5Ym_n4RQ7NuSXAMeta } from "/opt/buildhome/repo/pages/privacy-policy.vue?macro=true";
import { default as listlxAK_45iOtbcd4LB_MCShZCY1kqBhTVqOeBFMxPEhQKBMMeta } from "/opt/buildhome/repo/pages/cafe/owner/list.vue?macro=true";
import { default as newQQMzLGgAw6guuba7N_4k8OJA7MRRcwt0fc2hg2mIW1MMeta } from "/opt/buildhome/repo/pages/cafe/feature/new.vue?macro=true";
import { default as blog_45reviewY6kgDCD8Z5U_tLMNYCefdDu3dKIP4jVQ2XQB3lF4Pz8Meta } from "/opt/buildhome/repo/pages/admin/blog-review.vue?macro=true";
import { default as _91id_93VyPCWYgaEWOdAX73Fxy6GjzA1lzcCUk1vLhLcEuh6kQMeta } from "/opt/buildhome/repo/pages/cafe/owner/form/[id].vue?macro=true";
import { default as indexpjycktk57QtFqEPIuR_POHyBAa_45aV4tDyLlUUHscyFkMeta } from "/opt/buildhome/repo/pages/cafe/owner/form/index.vue?macro=true";
import { default as _91uuid_938_2ydrNjA_45xigP2R4oKFOY3IzuJlMrEB_T8fvHgP_45oIMeta } from "/opt/buildhome/repo/pages/profile-public/[uuid].vue?macro=true";
export default [
  {
    name: "index",
    path: "/",
    component: () => import("/opt/buildhome/repo/pages/index.vue")
  },
  {
    name: "login",
    path: "/login",
    component: () => import("/opt/buildhome/repo/pages/login.vue")
  },
  {
    name: "profile",
    path: "/profile",
    meta: profileR9_wsppREGZSR_45CuRHjAda5E9w1q2i4xh5hY7ddMHxQMeta || {},
    component: () => import("/opt/buildhome/repo/pages/profile.vue")
  },
  {
    name: "about-us",
    path: "/about-us",
    component: () => import("/opt/buildhome/repo/pages/about-us.vue")
  },
  {
    name: "cafe-new",
    path: "/cafe/new",
    meta: new1xYYwEQxiHsJKiTLvC5_ptHKrnAcOjs36nUFjEnY_1MMeta || {},
    component: () => import("/opt/buildhome/repo/pages/cafe/new.vue")
  },
  {
    name: "cafe-id",
    path: "/cafe/:id()",
    component: () => import("/opt/buildhome/repo/pages/cafe/[id].vue")
  },
  {
    name: "blog",
    path: "/blog",
    component: () => import("/opt/buildhome/repo/pages/blog/index.vue")
  },
  {
    name: "cafe",
    path: "/cafe",
    component: () => import("/opt/buildhome/repo/pages/cafe/index.vue")
  },
  {
    name: "Disclaimer",
    path: "/Disclaimer",
    component: () => import("/opt/buildhome/repo/pages/Disclaimer.vue")
  },
  {
    name: "blog-slug",
    path: "/blog/:slug()",
    component: () => import("/opt/buildhome/repo/pages/blog/[slug].vue")
  },
  {
    name: "admin-review",
    path: "/admin/review",
    meta: review7V42pK5IU0wWuQA2lYTZdARWq7CEey8su4sc8RfRopYMeta || {},
    component: () => import("/opt/buildhome/repo/pages/admin/review.vue")
  },
  {
    name: "admin-ig-queue",
    path: "/admin/ig-queue",
    meta: ig_45queue4jqERaVAxZs85kI6rhENnkEHIyFAiUIAUa_45ca_453lPFEMeta || {},
    component: () => import("/opt/buildhome/repo/pages/admin/ig-queue.vue")
  },
  {
    name: "privacy-policy",
    path: "/privacy-policy",
    component: () => import("/opt/buildhome/repo/pages/privacy-policy.vue")
  },
  {
    name: "cafe-owner-list",
    path: "/cafe/owner/list",
    component: () => import("/opt/buildhome/repo/pages/cafe/owner/list.vue")
  },
  {
    name: "cafe-feature-new",
    path: "/cafe/feature/new",
    meta: newQQMzLGgAw6guuba7N_4k8OJA7MRRcwt0fc2hg2mIW1MMeta || {},
    component: () => import("/opt/buildhome/repo/pages/cafe/feature/new.vue")
  },
  {
    name: "admin-blog-review",
    path: "/admin/blog-review",
    meta: blog_45reviewY6kgDCD8Z5U_tLMNYCefdDu3dKIP4jVQ2XQB3lF4Pz8Meta || {},
    component: () => import("/opt/buildhome/repo/pages/admin/blog-review.vue")
  },
  {
    name: "cafe-owner-form-id",
    path: "/cafe/owner/form/:id()",
    meta: _91id_93VyPCWYgaEWOdAX73Fxy6GjzA1lzcCUk1vLhLcEuh6kQMeta || {},
    component: () => import("/opt/buildhome/repo/pages/cafe/owner/form/[id].vue")
  },
  {
    name: "cafe-owner-form",
    path: "/cafe/owner/form",
    meta: indexpjycktk57QtFqEPIuR_POHyBAa_45aV4tDyLlUUHscyFkMeta || {},
    component: () => import("/opt/buildhome/repo/pages/cafe/owner/form/index.vue")
  },
  {
    name: "profile-public-uuid",
    path: "/profile-public/:uuid()",
    meta: _91uuid_938_2ydrNjA_45xigP2R4oKFOY3IzuJlMrEB_T8fvHgP_45oIMeta || {},
    component: () => import("/opt/buildhome/repo/pages/profile-public/[uuid].vue")
  }
]